<template>
  <div id="TheLoader" class="loader-component status-spinner"></div>
</template>

<script>
export default {
  name: 'TheLoader',
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables/variables.scss";
@import "@/assets/styles/bootstrap/_mixins.scss";

.status-spinner {
  z-index: 1000;
  margin: auto;
  font-size: 72px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-left: 2px solid gray;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: rotate360 1.0s infinite linear;
  animation: rotate360 1.0s infinite linear;
  border-radius: 50%;
  width: 125px;
  height: 125px;
  margin-left: -62.5px;
  margin-top: -62.5px;
  line-height: (125px - 4);
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
}

@include media-breakpoint-down(sm) {
  .status-spinner {
    width: 80px;
    height: 80px;
    line-height: 80px;
    margin-left: -40px;
    margin-top: -40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheLoader.vue